const KEY = "mm_cookie_consent";
const EVENT = "mm-cookie-settings";

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (!c) return null;
    const sixMonths = 1000 * 60 * 60 * 24 * 182;
    return Date.now() - new Date(c.at).getTime() > sixMonths ? null : c;
  } catch { return null; }
};

export const saveConsent = (stats) => {
  const consent = { essential: true, stats: !!stats, at: new Date().toISOString(), version: 1 };
  localStorage.setItem(KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent("mm-cookie-consent", { detail: consent }));
  return consent;
};

export const openCookieSettings = () => window.dispatchEvent(new Event(EVENT));
export const COOKIE_SETTINGS_EVENT = EVENT;
